import 'core-js/modules/es.promise';
import 'core-js/modules/es.set';
import 'core-js/modules/es.string.starts-with';
import 'core-js/modules/es.map';
import 'core-js/modules/es.weak-map';

import renderReactComponent from 'react_renderer';

import PartnerSubmissionApp from 'components/external_partners/partner_wizard_form/PartnerSubmissionApp';
import AffiliateInfoApp from 'components/external_partners/affiliate_info/AffiliateInfoApp';

window.renderPartnerSubmissionApp = renderReactComponent(PartnerSubmissionApp);
window.renderAffiliateInfoApp = renderReactComponent(AffiliateInfoApp);
